import { Injectable } from '@angular/core';
import { FavouriteListService } from './favourite-list.service';

export const FAVOURITE_ARTISTS_MAX = 400;

/** A saved artist as stored on the server. */
export interface FavouriteArtist {
  id: string;
  name: string;
  picture: string;
  fans: number;
  addedAt?: string;
}

/** The shape the artist grid renders (same as chart artists). */
export function toGridArtist(f: FavouriteArtist): any {
  return { id: f.id, name: f.name, images: [{ url: f.picture }], fans: f.fans, addedAt: f.addedAt };
}

@Injectable({ providedIn: 'root' })
export class FavouriteArtistsService extends FavouriteListService<FavouriteArtist> {
  protected readonly path = 'favourite-artists';
  protected readonly noun = 'Favourite Artists';
  readonly max = FAVOURITE_ARTISTS_MAX;

  /** The full saved list once loaded (the Favourite Artists page), otherwise null. */
  readonly artists = this.items;
}
